import type { DirectAdsFlight } from '../../../server/models/direct-ads'
import { directAdsFlightSchema } from '../../../server/models/direct-ads'
import { z } from 'zod'
import { getUnixTime } from 'date-fns'

export const useDirectAds = async (): Promise<DirectAdsFlight[]> => {
  const { data } = await useFetch('/api/v2/direct-ads', {
    retry: 0,
  })

  const parsedDirectAds = z.array(directAdsFlightSchema).safeParse(data.value)
  if (!parsedDirectAds.success) return []

  const currentTime = getUnixTime(new Date())
  const activeDirectAds = parsedDirectAds.data.filter(
    (campaign) =>
      currentTime >= campaign.campaignStartTime &&
      currentTime <= campaign.campaignEndTime
  )
  return activeDirectAds
}
